module.exports = __webpack_public_path__ + "img/simple-product-placeholder.c9619e31.svg";